'use client';

import { Inter } from 'next/font/google';
import { Providers } from './providers';
import TopBar from '@/components/TopBar';
import { Box } from '@chakra-ui/react';
import '@/styles/globals.css';
import { usePathname } from 'next/navigation';
import { ProtectedPage } from '@/components/auth/ProtectedPage';

const inter = Inter({ subsets: ['latin'] });

export default function RootLayout({
    children,
}: {
    children: React.ReactNode;
}) {
    const pathname = usePathname();
    const isLoginPage = pathname === '/login';

    return (
        <html lang="en">
            <head>
                <title>XO Digital - Cortex</title>
                <meta name="description" content="XO Digital - Cortex" />
            </head>
            <body className={inter.className} style={{ overflow: 'hidden', margin: 0, padding: 0 }}>
                <Providers>
                    <TopBar />
                    <Box
                        style={{ marginTop: '79px' }}
                        height="calc(100vh - 79px)"
                        overflowY="auto"
                        position="relative"
                        bg="transparent"
                    >
                        {isLoginPage ? (
                            children
                        ) : (
                            <ProtectedPage>
                                {children}
                            </ProtectedPage>
                        )}
                    </Box>
                </Providers>
            </body>
        </html>
    );
} 